import * as ALARMEMAIL from './alarmEmail.constants';
import { AlarmEmailDTO } from '../../models';

/** LOAD */
export function loadAlarmEmail() {
    return { type: ALARMEMAIL.ALARM_EMAIL_LOAD };
}

export function loadAlarmEmailSuccess(data: AlarmEmailDTO[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_LOAD_SUCCESS, payload: data };
}

export function loadAlarmEmailError(error: any) {
    return { type: ALARMEMAIL.ALARM_EMAIL_LOAD_ERROR, payload: error };
}


/** ADD */
export function addAlarmEmail(targetAlarmEmail: AlarmEmailDTO[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_ADD, payload: targetAlarmEmail };
}

export function addAlarmEmailSuccess(targetAlarmEmail: AlarmEmailDTO[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_ADD_SUCCESS, payload: targetAlarmEmail };
}

export function addAlarmEmailError(error: any) {
    return { type: ALARMEMAIL.ALARM_EMAIL_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateAlarmEmail(targetAlarmEmail: AlarmEmailDTO[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_UPDATE, payload: targetAlarmEmail };
}

export function updateAlarmEmailSuccess(targetAlarmEmail: AlarmEmailDTO[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_UPDATE_SUCCESS, payload: targetAlarmEmail };
}

export function updateAlarmEmailError(error: any) {
    return { type: ALARMEMAIL.ALARM_EMAIL_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteAlarmEmail(guids: string[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_DELETE, payload: guids };
}

export function deleteAlarmEmailSuccess(AlarmEmail: AlarmEmailDTO[]) {
    return { type: ALARMEMAIL.ALARM_EMAIL_DELETE_SUCCESS, payload: AlarmEmail };
}

export function deleteAlarmEmailError(error: any) {
    return { type: ALARMEMAIL.ALARM_EMAIL_DELETE_ERROR, payload: error };
}